import { render, staticRenderFns } from "./Privillge.vue?vue&type=template&id=4c21110c&"
import script from "./Privillge.vue?vue&type=script&lang=js&"
export * from "./Privillge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports